<script lang="ts">
  import SaveButton from "./SaveButton.svelte"
  import UserForm from "./UserForm.svelte"
  import MembersForm from "./MembersForm.svelte"
  import Card from "./Card.svelte"
  import { signupStore } from "$app/signupstore.svelte"
  import { catchError, formatter, toast, xhr } from "$app/utils"
  import Coupon from "./Coupon.svelte"
  import Honeybadger from "$app/utils/honeybadger"

  let { recaptcha_site_key_v3 }: { recaptcha_site_key_v3?: string } = $props()

  let saving = $state(false)

  let card = $state<Card>(null)
  let userForm = $state<UserForm>(null)
  let errors: Record<string, any> = $state({})

  async function getData(): Promise<Record<string, any> | false> {
    const cardToken = await card.getStripeToken()
    if (cardToken === "") {
      alert(
        "There was an error with the credit card verification. Please try again."
      )
      saving = false
      return false
    }

    const auth_token = (<HTMLMetaElement>(
      document.querySelector("meta[name=csrf-token]")
    )).content

    return {
      user: userForm.getData(),
      selected_plan_id: signupStore.selectedPlan.id,
      auth_token: auth_token,
      subscription: {
        full_access_total: signupStore.signupCount("full_access"),
        team_member_total: signupStore.signupCount("team_member"),
        recognition_member_total: signupStore.signupCount("recognition_member"),
        billing_interval: signupStore.billingInterval,
        subscription_type: signupStore.selectedPlan.id,
        name: signupStore.selectedPlan.name,
        stripe_coupon: signupStore.coupon.id,
        stripe_token: cardToken
      }
    }
  }

  async function getRecaptchaToken(): Promise<string> {
    let captcha_token: string = ""

    try {
      captcha_token = await window.grecaptcha.execute(recaptcha_site_key_v3, {
        action: "signup"
      })
    } catch (e: any) {
      alert("There was a captcha error. Please try again.")
      Honeybadger.notify(e)

      throw new Error("Captcha error")
    }

    return captcha_token
  }

  async function handleSubmit() {
    saving = true
    let captcha_token: string = await getRecaptchaToken()

    const data = await getData()

    const [error, resp] = await catchError(
      xhr.post("/signup", {
        ...data,
        "g-recaptcha-response-data": captcha_token
      })
    )
    if (error) {
      errors = error?.response?.data?.errors || {}
      saving = false
      let msg = "There are some errors. Please verify and try again."
      if (errors.name || errors.email || errors.password) {
        msg =
          "There are some errors on your account details. Please verify and try again"
      }
      toast(msg, "error", {
        duration: 15 * 60 * 1000
      })
      return
    }

    errors = {}
    saving = false
    if (resp.data?.redirection_path) {
      toast("Thank you for signing up!", "success")
      window.location.href = resp.data.redirection_path
    }
  }
</script>

<div class="bg-gray-50 order-1 md:order-2">
  <div class="px-6 py-5">
    <UserForm bind:this={userForm} {errors} />
  </div>

  <hr class="text-gray-200" />

  <div class="px-2 md:px-4">
    <MembersForm>
      {#snippet discountSnippet()}
        <div class="grid grid-cols-3 gap-2">
          <div class="col-span-2 flex items-center gap-2">
            Discount
            <Coupon onvalidating={(validating) => (saving = validating)} />
          </div>
          <div class="font-bold text-right leading-12">
            - {formatter.format(signupStore.discount)}
          </div>
        </div>
      {/snippet}
    </MembersForm>
  </div>

  <div class="px-2 py-4 md:px-4">
    <Card bind:this={card} />
  </div>

  <div class="px-4 py-2">
    <SaveButton bind:saving onclick={handleSubmit} />
  </div>
</div>
